/*
  LA sepet hediyesi (snippets/la-hediye.liquid). Sepeti /cart.js'ten okur:
  - hediye HARİÇ ücretli satırların toplamı eşiğin altındaysa: "X daha ekle" + çubuk
  - eşik aşıldıysa havuzdan (Freebies koleksiyonundaki $0 ürünler, ?view=la-hediye-json) bir
    hediye seçip `_hediye` özelliğiyle sepete ekler; altına düşülürse otomatik eklenen hediyeyi
    çıkarır. Seçim: sepetteki ücretli ürünün satıcısının kendi ücretsiz ürünü → aynı tür → ilk.
  - Hediye satırı `_hediye` özelliğinden tanınır. Fiyatı $0 olmayan `_hediye` satırı (24 Eki
    öncesinin $12'lik Illustrated Characters hediyesi) sepetten kendiliğinden çıkarılır.
  - Müşteri hediyeyi kendisi silerse o sepette geri eklemez (işaret sepet token'ına bağlı:
    sipariş verilip yeni sepet açılınca hediye yine eklenir).
*/
(function () {
  if (window.__laHediye) return;
  window.__laHediye = true;
  var para;
  try { para = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); }
  catch (e) { para = { format: function (n) { return '$' + n.toFixed(2); } }; }
  var mesgul = false, bekleyen = false;
  var ss = { al: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }, koy: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  function kutular() { return document.querySelectorAll('[data-la-hediye]'); }
  var havuzOnbellek = null, HAVUZ_ANAHTAR = 'la-hediye-havuz-v2', HAVUZ_OMUR = 3600000;
  function havuz() { return havuzOnbellek || []; }
  function temizle(h) { return (Array.isArray(h) ? h : []).filter(function (x) { return x && x.v; }); }
  // Havuz oturumda 1 saat saklanır; çekilemezse boş kalır (hediye eklenmez, sepet bozulmaz)
  function havuzYukle(k) {
    if (havuzOnbellek) return Promise.resolve(havuzOnbellek);
    try { var s = JSON.parse(ss.al(HAVUZ_ANAHTAR) || 'null'); if (s && Date.now() - s.z < HAVUZ_OMUR && s.h.length) { havuzOnbellek = temizle(s.h); return Promise.resolve(havuzOnbellek); } } catch (e) {}
    // Accept: application/json GÖNDERME: Shopify o zaman ?view görünümü yerine koleksiyonun kendi JSON'unu döndürüyor
    return fetch(k.getAttribute('data-havuz')).then(function (r) { return r.json(); })
      .then(function (h) { havuzOnbellek = temizle(h); if (havuzOnbellek.length) ss.koy(HAVUZ_ANAHTAR, JSON.stringify({ z: Date.now(), h: havuzOnbellek })); return havuzOnbellek; })
      .catch(function () { return []; });
  }
  function hediyeMi(i) { return !!(i.properties && i.properties._hediye); }
  function nitelikliToplam(c) {
    var t = 0;
    (c.items || []).forEach(function (i) { if (i.price > 0 && !hediyeMi(i)) t += i.original_line_price; });
    return t;
  }
  // Sepette olmayan havuz ürünlerinden: 1) ücretli ürünün satıcısının kendi ücretsiz ürünü
  // (pahalı üründen başlayarak), 2) ücretli ürünlerle aynı tür, 3) havuzun ilki (en çok indirilen)
  function hediyeSec(c) {
    var sepette = {};
    (c.items || []).forEach(function (i) { sepette[String(i.variant_id)] = 1; });
    var odenen = (c.items || []).filter(function (i) { return i.price > 0 && !hediyeMi(i); })
      .sort(function (a, b) { return b.original_line_price - a.original_line_price; });
    var aday = havuz().filter(function (x) { return !sepette[String(x.v)]; });
    var bul = function (alan, deger) { for (var k = 0; k < aday.length; k++) if (deger && aday[k][alan] === deger) return aday[k]; return null; };
    var x, n;
    for (n = 0; n < odenen.length; n++) if ((x = bul('vd', odenen[n].vendor))) return x;
    for (n = 0; n < odenen.length; n++) if ((x = bul('ty', odenen[n].product_type))) return x;
    return aday[0] || null;
  }
  function havuzda(vid) {
    var h = havuz();
    for (var k = 0; k < h.length; k++) if (String(h[k].v) === String(vid)) return h[k];
    return null;
  }

  function ciz(c) {
    kutular().forEach(function (k) {
      var esik = parseInt(k.getAttribute('data-esik'), 10);
      var nitelikli = nitelikliToplam(c);
      var satir = null;
      (c.items || []).forEach(function (i) { if (hediyeMi(i) && i.price === 0) satir = i; });
      var hediyeVar = !!satir;
      var secilen = satir ? (havuzda(satir.variant_id) || { t: satir.product_title, c: 0, i: satir.image || '' }) : hediyeSec(c);
      var metin = k.querySelector('[data-hediye-metin]'), dolu = k.querySelector('[data-hediye-dolu]');
      var gorsel = k.querySelector('[data-hediye-gorsel]');
      k.hidden = !(c.item_count > 0) || !secilen;
      if (!secilen) return;
      var ad = kacis(secilen.t);
      var deger = secilen.c > 0 ? ' (' + para.format(secilen.c / 100) + ' value)' : '';
      if (gorsel) {
        if (secilen.i) { gorsel.src = secilen.i; gorsel.alt = secilen.t; gorsel.hidden = false; }
        else gorsel.hidden = true;
      }
      var oran = Math.min(100, Math.round(nitelikli / esik * 100));
      dolu.style.width = oran + '%';
      k.classList.toggle('la-hediye--tamam', nitelikli >= esik);
      if (nitelikli >= esik) {
        metin.innerHTML = hediyeVar
          ? '<strong>Free gift unlocked:</strong> ' + ad + deger + ' is in your cart.'
          : '<strong>Free gift unlocked:</strong> ' + ad + deger + '.';
      } else {
        metin.innerHTML = 'Add <strong>' + para.format((esik - nitelikli) / 100) + '</strong> more and get <strong>' + ad + '</strong> free' + deger + '.';
      }
    });
  }

  /* ---- Sepet önerileri: sepetteki ücretli ürünlerin "Pairs well with" eşleri ---- */
  var esOnbellek = {};
  function esleriAl(handle) {
    if (esOnbellek[handle]) return Promise.resolve(esOnbellek[handle]);
    var k = 'la-es-' + handle, s = ss.al(k);
    if (s) { try { esOnbellek[handle] = JSON.parse(s); return Promise.resolve(esOnbellek[handle]); } catch (e) {} }
    return fetch('/products/' + encodeURIComponent(handle) + '?view=la-esles-json').then(function (r) { return r.json(); })
      .then(function (j) { esOnbellek[handle] = j; ss.koy(k, JSON.stringify(j)); return j; })
      .catch(function () { return { esler: [] }; });
  }
  function kacis(x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function oneriler(c) {
    var kutu = document.querySelector('[data-la-oneri]'), hk = kutular()[0];
    if (!kutu || !hk) return;
    var esik = parseInt(hk.getAttribute('data-esik'), 10);
    var sepette = {}, nitelikli = nitelikliToplam(c);
    (c.items || []).forEach(function (i) { sepette[String(i.variant_id)] = 1; });
    if (!c.item_count) { kutu.hidden = true; return; }
    var kaynaklar = (c.items || []).filter(function (i) { return i.price > 0 && !hediyeMi(i); }).slice(0, 3);
    Promise.all(kaynaklar.map(function (i) { return esleriAl(i.handle).then(function (j) { return { j: j, kaynak: i.product_title }; }); }))
      .then(function (sonuc) {
        var aday = [], gor = {};
        sonuc.forEach(function (s) { (s.j.esler || []).forEach(function (e) {
          if (!sepette[String(e.id)] && !gor[e.id]) { gor[e.id] = 1; e.kaynak = s.kaynak; aday.push(e); }
        }); });
        if (!aday.length) {
          var yedek = [];
          try { yedek = JSON.parse(kutu.querySelector('[data-oneri-yedek]').textContent); } catch (e) {}
          yedek.forEach(function (e) { if (!sepette[String(e.id)] && !gor[e.id]) { gor[e.id] = 1; e.kaynak = 'Cart'; aday.push(e); } });
        }
        // Hediyeye kalan varsa ve eşlerden hiçbiri kalanı tek başına kapatmıyorsa,
        // yedek listeden kapatan en ucuz çok satanı ekle (kalan tek tıkla kapansın)
        var kalan = esik - nitelikli;
        if (kalan > 0 && !aday.some(function (e) { return e.p >= kalan; })) {
          var yedek2 = [];
          try { yedek2 = JSON.parse(kutu.querySelector('[data-oneri-yedek]').textContent); } catch (e) {}
          var kapatan = yedek2.filter(function (e) { return e.p >= kalan && !sepette[String(e.id)] && !gor[e.id]; })
            .sort(function (a, b) { return a.p - b.p; })[0];
          if (kapatan) { kapatan.kaynak = 'Cart'; aday.unshift(kapatan); }
        }
        if (kalan > 0) aday.sort(function (a, b) { var ak = a.p >= kalan, bk = b.p >= kalan; if (ak !== bk) return ak ? -1 : 1; return ak ? a.p - b.p : b.p - a.p; });
        // 4'e tamamla: eksik yerleri en çok satanlarla doldur (sepette olanlar hariç)
        if (aday.length < 4) {
          var dolgu = [];
          try { dolgu = JSON.parse(kutu.querySelector('[data-oneri-yedek]').textContent); } catch (e) {}
          dolgu.forEach(function (e) { if (aday.length < 4 && !sepette[String(e.id)] && !aday.some(function (a) { return a.id === e.id; })) { e.kaynak = 'Cart'; aday.push(e); } });
        }
        aday = aday.slice(0, 4);
        var d = window.laKampanyaEtkin ? window.laKampanyaEtkin() : null;
        var oran = d && d.tur === 'satis' && !d.koleksiyon ? d.oran : 0; // koleksiyona bağlı kampanyada sepet önerisinde kodlu fiyat yok
        kutu.querySelector('[data-oneri-liste]').innerHTML = aday.map(function (e) {
          var fiyat = oran ? '<s>' + para.format(e.p / 100) + '</s> <strong>' + para.format((e.p - Math.round(e.p * oran / 100)) / 100) + '</strong>'
            : (e.c > e.p ? '<s>' + para.format(e.c / 100) + '</s> ' : '') + '<strong>' + para.format(e.p / 100) + '</strong>';
          var kapatir = kalan > 0 && e.p >= kalan ? '<em class="la-oneri__rozet">Unlocks your free gift</em>' : '';
          return '<li class="la-oneri__kart">' + kapatir +
            '<a class="la-oneri__gorsel" href="' + kacis(e.u) + '">' + (e.i ? '<img src="' + kacis(e.i.replace('width=160', 'width=400')) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<a class="la-oneri__ad" href="' + kacis(e.u) + '">' + kacis(e.t) + '</a>' +
            '<span class="la-oneri__fiyat">' + fiyat + '</span>' +
            '<button type="button" class="la-oneri__ekle" data-oneri-ekle="' + e.id + '" data-oneri-kaynak="' + kacis(e.kaynak || 'Cart') + '" aria-label="Add ' + kacis(e.t) + ' to cart">+ Add to cart</button></li>';
        }).join('');
        kutu.hidden = !aday.length;
      });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-oneri-ekle]');
    if (!b) return;
    ev.preventDefault();
    b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-oneri-ekle'), 10), quantity: 1, properties: { _pair: 'Cart: ' + b.getAttribute('data-oneri-kaynak') } }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); b.textContent = 'Added ✓'; })
      .catch(function () { b.disabled = false; b.textContent = '+ Add to cart'; })
      .then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
      });
  });

  function yenile() {
    var k = kutular()[0];
    if (!k) return;
    if (mesgul) { bekleyen = true; return; }
    mesgul = true;
    var esik = parseInt(k.getAttribute('data-esik'), 10);
    havuzYukle(k).then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); }).then(function (r) { return r.json(); }).then(function (c) {
      var nitelikli = nitelikliToplam(c), hediye = null, eski = null;
      (c.items || []).forEach(function (i) {
        if (!hediyeMi(i)) return;
        if (i.price > 0) eski = eski || i; // ücretli hediye satırı: eski sistemden kalma, çıkar
        else hediye = hediye || i;
      });
      var islem = null, secilen = null;
      if (eski) {
        islem = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: eski.key, quantity: 0 }) })
          .then(function () { bekleyen = true; });
      } else {
        // Müşteri otomatik eklenen hediyeyi bu sepette sildiyse bir daha ekleme
        var jeton = String(c.token || '1');
        if (!hediye && ss.al('la-hediye-eklendi') === jeton && nitelikli >= esik) ss.koy('la-hediye-kaldirildi', jeton);
        if (nitelikli >= esik && !hediye && ss.al('la-hediye-kaldirildi') !== jeton && (secilen = hediyeSec(c))) {
          islem = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: secilen.v, quantity: 1, properties: { _hediye: '1' } }] }) })
            .then(function () { ss.koy('la-hediye-eklendi', jeton); });
        } else if (nitelikli < esik && hediye) {
          islem = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: hediye.key, quantity: 0 }) })
            .then(function () { ss.koy('la-hediye-eklendi', '0'); });
        }
      }
      if (!islem) { ciz(c); oneriler(c); return null; }
      return islem.then(function () {
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c2) { ciz(c2); oneriler(c2); });
      });
    }).catch(function () {}).then(function () {
      mesgul = false;
      if (bekleyen) { bekleyen = false; setTimeout(yenile, 200); }
    });
  }

  ['theme:cart:add', 'theme:cart:change', 'theme:cart:refresh', 'theme:cart-drawer:show'].forEach(function (ad) {
    document.addEventListener(ad, function () { setTimeout(yenile, 700); });
  });
  // Çekmece kendi içeriğini yenileyince (adet değişimi vb.) tekrar bak
  var son = 0;
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-items-holder], cart-items, .cart__table-body')) {
      var t = Date.now(); if (t - son > 300) { son = t; setTimeout(yenile, 1200); }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', yenile); else yenile();
})();
